"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _default = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);

  function _default(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this, props));
    _this.state = {
      modalOpen: null
    };
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        modalOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var defaultOpen = this.props.defaultOpen;
      var modalOpen = this.state.modalOpen;
      return _react["default"].createElement(_semanticUiReact.Modal, {
        className: "item-cart-modal checkout-disabled-modal",
        dimmer: "inverted",
        open: modalOpen === false ? false : defaultOpen,
        onClose: this.closeModal
      }, _react["default"].createElement(_semanticUiReact.Modal.Header, null, "We're closed right now"), _react["default"].createElement(_semanticUiReact.Modal.Content, null, _react["default"].createElement(_semanticUiReact.Modal.Description, null, "Thanks for visiting. We're currently closed, but you can still view our menu.")), _react["default"].createElement(_semanticUiReact.Modal.Actions, null, _react["default"].createElement(_semanticUiReact.Button, {
        onClick: this.closeModal,
        primary: true
      }, "View Menu")));
    }
  }]);
  return _default;
}(_react["default"].Component);

exports["default"] = _default;